import { render, staticRenderFns } from "./ScoreCreate.vue?vue&type=template&id=ad581810"
import script from "./ScoreCreate.vue?vue&type=script&lang=js"
export * from "./ScoreCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports